import { render, staticRenderFns } from "./CompanySettingsPage.vue?vue&type=template&id=50f70beb&lang=pug&"
import script from "./CompanySettingsPage.vue?vue&type=script&lang=js&"
export * from "./CompanySettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./CompanySettingsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports